// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"P3-z","colorTextValue":"Q3-z","swatches":"R3-z","collapseLink":"S3-z","isCollapsed":"T3-z","dropdown":"U3-z","disabled":"V3-z"};